import { usePersistedQueryParams } from '@plato/app-shared/hooks/use-persisted-query-params';
import {
    customerListParamsConfig,
    defaultCustomerListSorting,
    type CustomerListParams,
} from '@plato/app-shared/utils/customer-list';
import type { SetValue } from '@plato/ui-legacy/lib/hooks/use-query-params';

export type CustomerListParamsState = {
    params: CustomerListParams;
    setParams: SetValue<CustomerListParams>;
    defaultParams: CustomerListParams;
};

const defaultParams: CustomerListParams = { sorting: defaultCustomerListSorting };

export function useCustomerListParams(): CustomerListParamsState {
    const [params, setParams] = usePersistedQueryParams(
        customerListParamsConfig,
        defaultParams,
        'customer-list-v2',
    );

    return { params, setParams, defaultParams };
}
